export default "__VITE_ASSET__b31ddad8__"